// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { AspNetUserClaim } from './asp-net-user-claim';
import { AspNetUserRole } from './asp-net-user-role';
import { AspNetUserToken } from './asp-net-user-token';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AspNetUser extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  accessFailedCount!: number;
  concurrencyStamp?: string;
  createdAt?: Date;
  creditorCode?: string;
  email?: string;
  emailConfirmed!: boolean;
  insolvencyUserId?: number;
  isPracticeUser!: boolean;
  lockoutEnabled!: boolean;
  lockoutEnd?: Date;
  lockoutEndDateUtc?: Date;
  normalizedEmail?: string;
  normalizedUserName?: string;
  passwordHash?: string;
  phoneNumber?: string;
  phoneNumberConfirmed!: boolean;
  salutation?: string;
  securityStamp?: string;
  startDate?: Date;
  twoFactorEnabled!: boolean;
  userName!: string;
  aspNetUserClaims!: AspNetUserClaim[];
  aspNetUserRoles!: AspNetUserRole[];
  aspNetUserTokens!: AspNetUserToken[];
}

